import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-analysis-delete",
  "use": "app-icon-analysis-delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-analysis-delete\"><path d=\"M9.1 8l5.3-5.3c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L8 6.9 2.7 1.6c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1L6.9 8l-5.3 5.3c-.3.3-.3.8 0 1.1s.8.3 1.1 0L8 9.1l5.3 5.3c.3.3.8.3 1.1 0s.3-.8 0-1.1L9.1 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol